import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=a670f8ac&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=a670f8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a670f8ac",
  null
  
)

export default component.exports